// extracted by mini-css-extract-plugin
var _1 = "gray";
export { _1 as "gray" }
